import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface HabilitarModoToggleProps {
  value: 'NUC' | 'INSTANCIA';
  onChange: (value: 'NUC' | 'INSTANCIA') => void;
  label?: string;
}

/**
 * Segmented control "Habilitar por: NUC | Instancia" — extraído de HabilitarBuzonModal para reutilizarlo
 * también en la rehabilitación de un caso DESHABILITADO (punto 4), que ahora ofrece la misma elección.
 */
const HabilitarModoToggle = ({ value, onChange, label }: HabilitarModoToggleProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography sx={{ fontSize: '0.78rem', fontWeight: 500, color: '#6b7280', mb: 0.75 }}>
        {label ?? t('buzonJudicial.enableModal.title', 'Habilitar por')}
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => { if (newValue) onChange(newValue); }}
        sx={{
          display: 'flex',
          width: '100%',
          backgroundColor: '#f1f5f9',
          borderRadius: '10px',
          padding: '4px',
          gap: '4px',
          '& .MuiToggleButtonGroup-grouped': {
            flex: 1,
            border: 0,
            borderRadius: '8px !important',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.85rem',
            py: 0.75,
            color: '#64748b',
            backgroundColor: 'transparent',
            '&:hover': { backgroundColor: 'rgba(15,23,42,0.04)' },
            '&.Mui-selected': {
              backgroundColor: '#ffffff',
              color: '#0f172a',
              boxShadow: '0 1px 3px rgba(15,23,42,0.14)',
            },
            '&.Mui-selected:hover': { backgroundColor: '#ffffff' },
          },
        }}
      >
        <ToggleButton value="NUC">{t('buzonJudicial.enableModal.optionNuc', 'Número único de caso')}</ToggleButton>
        <ToggleButton value="INSTANCIA">{t('buzonJudicial.enableModal.optionInstancia', 'Instancia')}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default HabilitarModoToggle;
